import { render } from "./FooterMy.vue?vue&type=template&id=9ed1f0ce&scoped=true"
import script from "./FooterMy.vue?vue&type=script&lang=js"
export * from "./FooterMy.vue?vue&type=script&lang=js"

import "./FooterMy.vue?vue&type=style&index=0&id=9ed1f0ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Oscar Daniel\\Desktop\\X LAUCHER\\TRABAJANDO\\05 - VUE\\Ejercio 2\\pasteleria-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ed1f0ce"]])

export default __exports__